module.exports = __webpack_public_path__ + "static/media/shoot2.0ad98876.wav";